import { type ReactNode, createContext } from 'react'

import { type SanityFrameBuilderStrings } from '../data/sanity/queries/types/strings'

interface FrameBuilderStringsProviderProps {
  strings: SanityFrameBuilderStrings
  children: ReactNode
}

export const FrameBuilderStringsContext =
  createContext<SanityFrameBuilderStrings>({
    artworkSizeStepTitle: '',
    artworkSizeSizeNotValid: '',
    artworkSizeWidthAndHeightDescription: [],
    artworkSizeNoSelection: '',
    artworkSizeNoWidthSelected: '',
    artworkSizeNoHeightSelected: '',
    artworkSizeOutOfProfileLimits: '',
    artworkSizeStepFooter: [],
    artworkPreviewStepTitle: '',
    artworkPreviewArtworkDescription: [],
    artworkPreviewNoSelection: '',
    artworkPreviewStepFooter: [],
    frameStyleStepTitle: '',
    frameStyleProfileNotValid: '',
    frameStyleTextureNotValid: '',
    frameStyleTextureDescription: [],
    frameStyleProfileDescription: [],
    frameStyleStepFooter: [],
    passepartoutStepTitle: '',
    passepartoutSizeNotValid: '',
    passepartoutColorNotValid: '',
    passepartoutSizeDescription: [],
    passepartoutColorDescription: [],
    passepartoutStepFooter: [],
    glassStepTitle: '',
    glassTypeNotValid: '',
    glassTypeDescription: [],
    glassStepFooter: [],
    extrasStepTitle: '',
    extrasSpacerDescription: [],
    extrasStepFooter: [],
    discountPercentLabel: '',
    controlCancelLabel: '',
    controlOkLabel: '',
    controlChooseProductHint: '',
    controlAddToCartHint: '',
    controlQuantityLabel: '',
    controlPriceLabel: '',
    controlAddToCartLabel: '',
    controlAddingToCartLabel: '',
    addProductError: '',
  })

export const FrameBuilderStringsProvider = ({
  strings,
  children,
}: FrameBuilderStringsProviderProps) => {
  return (
    <FrameBuilderStringsContext.Provider value={strings}>
      {children}
    </FrameBuilderStringsContext.Provider>
  )
}
